export const colors={
    success: '#12B76A',
    pending: '#DABF2F',
    error: '#F15A25',
    background: '#F8F8F8',
    itemsBackground: '#E1E1E1',
    textGray: '#939393',
    black: "#000000",
    white: "#FFFFFF"
}